<template>
    <div id="Dashboard">   
        <div class="mission-section-dashboard">
            <h4 class="welcome-text">
                Welcome
            </h4>
        </div>

        <div class="dashboard-dashboard">

            <!-- LifeLink -->
            <div class="lifelink-card-dashboard card-dashboard devices-dashboard" @click="changeApp('lifelink')" style="text-align: center; background-color: #f6fdfb; border: 1px solid rgb(71, 215, 172); height: 141px;">
                <div style="border-radius: 50%; display: inline-block; padding: 15px; background: #daf7ee; margin-bottom: 10px; margin-top: 3px;">
                  <svg focusable="false" aria-hidden="true" class="chakra-icon chakra-icon css-1k9qhgh" width="32px" height="32px" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g><mask maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16" style="mask-type: alpha;"><rect width="16" height="16" fill="currentColor"></rect></mask><g mask="url(#mask0_1612_19788)"><path d="M12.6665 6.00002C12.0332 6.00002 11.4832 5.81113 11.0165 5.43335C10.5498 5.05558 10.2387 4.5778 10.0832 4.00002H5.89984C5.77761 4.46669 5.54706 4.86946 5.20817 5.20835C4.86928 5.54724 4.4665 5.7778 3.99984 5.90002V10.0834C4.57761 10.2389 5.05539 10.55 5.43317 11.0167C5.81095 11.4834 5.99984 12.0334 5.99984 12.6667C5.99984 13.4 5.73873 14.0278 5.2165 14.55C4.69428 15.0722 4.0665 15.3334 3.33317 15.3334C2.59984 15.3334 1.97206 15.0722 1.44984 14.55C0.927615 14.0278 0.666504 13.4 0.666504 12.6667C0.666504 12.0334 0.855393 11.4834 1.23317 11.0167C1.61095 10.55 2.08873 10.2389 2.6665 10.0834V5.90002C2.08873 5.74446 1.61095 5.43335 1.23317 4.96669C0.855393 4.50002 0.666504 3.95558 0.666504 3.33335C0.666504 2.60002 0.927615 1.97224 1.44984 1.45002C1.97206 0.927798 2.59984 0.666687 3.33317 0.666687C3.95539 0.666687 4.49984 0.855576 4.9665 1.23335C5.43317 1.61113 5.74428 2.08891 5.89984 2.66669H10.0832C10.2387 2.08891 10.5498 1.61113 11.0165 1.23335C11.4832 0.855576 12.0332 0.666687 12.6665 0.666687C13.3998 0.666687 14.0276 0.927798 14.5498 1.45002C15.0721 1.97224 15.3332 2.60002 15.3332 3.33335C15.3332 4.06669 15.0721 4.69446 14.5498 5.21669C14.0276 5.73891 13.3998 6.00002 12.6665 6.00002ZM3.33317 14C3.69984 14 4.01373 13.8667 4.27484 13.6C4.53595 13.3334 4.6665 13.0222 4.6665 12.6667C4.6665 12.3 4.53595 11.9861 4.27484 11.725C4.01373 11.4639 3.69984 11.3334 3.33317 11.3334C2.97761 11.3334 2.6665 11.4639 2.39984 11.725C2.13317 11.9861 1.99984 12.3 1.99984 12.6667C1.99984 13.0222 2.13317 13.3334 2.39984 13.6C2.6665 13.8667 2.97761 14 3.33317 14ZM3.33317 4.66669C3.69984 4.66669 4.01373 4.53613 4.27484 4.27502C4.53595 4.01391 4.6665 3.70002 4.6665 3.33335C4.6665 2.96669 4.53595 2.6528 4.27484 2.39169C4.01373 2.13058 3.69984 2.00002 3.33317 2.00002C2.97761 2.00002 2.6665 2.13058 2.39984 2.39169C2.13317 2.6528 1.99984 2.96669 1.99984 3.33335C1.99984 3.70002 2.13317 4.01391 2.39984 4.27502C2.6665 4.53613 2.97761 4.66669 3.33317 4.66669ZM12.6665 15.3334C11.9332 15.3334 11.3054 15.0722 10.7832 14.55C10.2609 14.0278 9.99984 13.4 9.99984 12.6667C9.99984 11.9334 10.2609 11.3056 10.7832 10.7834C11.3054 10.2611 11.9332 10 12.6665 10C13.3998 10 14.0276 10.2611 14.5498 10.7834C15.0721 11.3056 15.3332 11.9334 15.3332 12.6667C15.3332 13.4 15.0721 14.0278 14.5498 14.55C14.0276 15.0722 13.3998 15.3334 12.6665 15.3334ZM12.6665 14C13.0332 14 13.3471 13.8667 13.6082 13.6C13.8693 13.3334 13.9998 13.0222 13.9998 12.6667C13.9998 12.3 13.8693 11.9861 13.6082 11.725C13.3471 11.4639 13.0332 11.3334 12.6665 11.3334C12.2998 11.3334 11.9859 11.4639 11.7248 11.725C11.4637 11.9861 11.3332 12.3 11.3332 12.6667C11.3332 13.0222 11.4637 13.3334 11.7248 13.6C11.9859 13.8667 12.2998 14 12.6665 14ZM12.6665 4.66669C13.0332 4.66669 13.3471 4.53613 13.6082 4.27502C13.8693 4.01391 13.9998 3.70002 13.9998 3.33335C13.9998 2.96669 13.8693 2.6528 13.6082 2.39169C13.3471 2.13058 13.0332 2.00002 12.6665 2.00002C12.2998 2.00002 11.9859 2.13058 11.7248 2.39169C11.4637 2.6528 11.3332 2.96669 11.3332 3.33335C11.3332 3.70002 11.4637 4.01391 11.7248 4.27502C11.9859 4.53613 12.2998 4.66669 12.6665 4.66669Z" fill="currentColor"></path></g></g></svg>
                </div>
                <p class="card-title-dashboard">LifeLink</p>
            </div>

            <!-- workflow -->
            <div class="workflow-card-dashboard card-dashboard devices-dashboard" @click="changeApp('workflow')" style="text-align: center; background-color: #fbfdfe; border: 1px solid #4299e199; height: 141px;">
              <div style="border-radius: 50%; display: inline-block; padding: 15px; background: #eff7fa; margin-bottom: 10px; margin-top: 3px;">
                <svg focusable="false" aria-hidden="true" class="chakra-icon chakra-icon css-1k9qhgh" xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 -960 960 960" fill="currentColor"><path d="M360-600v-80h360v80H360Zm0 120v-80h360v80H360Zm120 320H200h280Zm0 80H240q-50 0-85-35t-35-85v-120h120v-560h600v361q-20-2-40.5 1.5T760-505v-295H320v480h240l-80 80H200v40q0 17 11.5 28.5T240-160h240v80Zm80 0v-123l221-220q9-9 20-13t22-4q12 0 23 4.5t20 13.5l37 37q8 9 12.5 20t4.5 22q0 11-4 22.5T903-300L683-80H560Zm300-263-37-37 37 37ZM620-140h38l121-122-18-19-19-18-122 121v38Zm141-141-19-18 37 37-18-19Z"></path></svg>
              </div>
              <p class="card-title-dashboard">Workflow</p>
            </div>

        </div>

        <!-- <div class="mission-section-dashboard" style="display: none;">
            <h4>Mission Statement</h4>
            <div class="mission-content-dashboard">
                <p>
                    We assist service providers in achieving superior preserved biomaterial outcomes through Vitrafy’s LifeChain integrated cryopreservation technology. Our solution, optimised with IoT, AI, and Blockchain, ensures the highest level of quality, surpassing current methods.
                </p>
                <img src="../assets/images/lock.png" alt="Security Lock Icon" class="lock-icon-dashboard">
            </div>
        </div> -->
    
    </div>    
</template>

<script>
    export default {
        name: 'dashboard',
        data: function () {
            return {
                test: "test data",
            };
        },
        props: [],
        methods: {
            changeApp: function (app) {
                console.log(app);
                this.$parent.changeApp(app);
            }            
        },
        mounted: function () {    

        }
    }
</script>

<style>
    .welcome-text {
      font-size: 28px;
      font-weight: 400 !important
    }

    .dashboard-dashboard {
      display: flex;
      gap: 26px;
      margin-bottom: 40px;
    }

    .card-dashboard {
      flex: 1;
      padding: 20px;
      border-radius: 5px;
      color: #000;
      position: relative;
      height: 155px;;
    }

    .card-dashboard:hover {
      cursor: pointer;
    }    

    /* .lifelink-card-dashboard:hover {
      cursor: pointer;
      background-color: #edfbf7 !important;
    }

    .workflow-card-dashboard:hover {
      cursor: pointer;
      background-color: #f7fbfc !important;
    }     */

    .devices-dashboard {
      background-color: #47d7ac;
    }

    .smart-contracts-dashboard {
      background-color: #0047ab; 
      color: #fff;
    }

    .locations-dashboard {
      background-color: #add8e6;
    }

    .card-title-dashboard {
      /* font-weight: bold; */
      margin-bottom: 10px;
      font-size: 16px;
    }

    .card-number-dashboard {
      font-size: 2em;
      margin-bottom: 20px;
    }

    .card-link-dashboard {
      text-decoration: none;
      color: inherit;
      /* font-weight: bold; */
      position: absolute;
      bottom: 20px;
      right: 20px;
      font-size: 18px;;
    }

    .mission-section-dashboard {
      /* margin-top: 40px; */
    }

    .mission-section-dashboard h2 {
      font-size: 28px;
      margin-bottom: 20px;
    }

    .mission-section-dashboard h4 {
        margin-bottom: 15px;
    }

    .mission-content-dashboard {
      background-color: #edfbf7;
      padding: 30px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .mission-content-dashboard p {
      max-width: 80%;
      font-size: 18px;
      color: #333;
    }

    .lock-icon-dashboard {
      height: 160px;
    }

    @media (max-width: 768px) {
      .dashboard-dashboard {
        flex-direction: column;
      }
      .mission-content-dashboard {
        flex-direction: column;
        text-align: center;
      }
      .mission-content-dashboard p {
        max-width: 100%;
        margin-bottom: 20px;
      }
    }
</style>